import '../components.scss'


type SectionProps = {
    children?:
    | React.ReactChild
    | React.ReactChild[];
    centered?: boolean,
    nopadding?: boolean,
    delimeter?: boolean
}

export const Section: React.FC<SectionProps> = ({ children, centered, nopadding, delimeter }) => {
    return (
        <>
            <div className={"section" + (centered ? " centered" : "") + (nopadding ? " nopadding" : "")}>
                {children}
            </div>
            {delimeter ? <hr className="section-hr"></hr> : ""}
        </>
    )
}